import { Accent2Badge } from 'src/components/Badge';
import { GeneralError } from 'src/models/error.model';
import { P6 } from 'src/components/Typography';

import classes from './FormError.module.scss';

export function FormError({ id, message }: GeneralError) {
  return (
    <div data-testid='form-error' className='column a-start items-p4 w-100p'>
      <Accent2Badge label={`ID: ${id}`} isSmall />
      <P6 className={classes.text}>{message}</P6>
    </div>
  );
}
